import React from 'react';
import { Modal } from 'antd';
import i18n from '../i18n';

/**
 * Champs d'un document dont l'absence mérite une confirmation avant impression.
 *
 * POURQUOI PRÉVENIR PLUTÔT QUE BLOQUER. Un dossier peut légitimement partir sans
 * le numéro de sinistre chez l'assureur : l'homologue ne l'a pas toujours
 * communiqué. Refuser l'impression immobiliserait le règlement pour une donnée
 * que le Bureau ne détient pas. Mais laisser sortir la pièce en silence produit
 * une quittance trouée que personne ne remarque avant qu'elle ne soit signée.
 *
 * ON NOMME CE QUI MANQUE. Un avertissement générique ne dit pas quoi vérifier ;
 * la liste des champs absents permet de décider en connaissance de cause, et
 * d'aller les renseigner si on les a sous la main.
 */
export const estVide = (valeur) =>
  valeur == null ||
  (typeof valeur === 'string' && (valeur.trim() === '' || valeur.trim() === '-'));

/**
 * Demande confirmation si l'un des champs est absent, puis imprime.
 *
 * @param champs  [{ libelle, valeur }]
 * @param imprimer appelé si rien ne manque, ou après confirmation
 */
export async function confirmerChampsManquants(champs, imprimer) {
  const manquants = (champs || []).filter((c) => estVide(c.valeur));
  if (manquants.length === 0) {
    await imprimer();
    return;
  }

  Modal.confirm({
    title: i18n.t('referentiels:impression.titre'),
    content: (
      <>
        <p style={{ margin: '0 0 8px' }}>
          {i18n.t('referentiels:impression.manquants', { count: manquants.length })}
        </p>
        <ul style={{ margin: '0 0 8px', paddingLeft: 20 }}>
          {manquants.map((c) => <li key={c.libelle}>{c.libelle}</li>)}
        </ul>
        <p style={{ margin: 0 }}>{i18n.t('referentiels:impression.question')}</p>
      </>
    ),
    okText: i18n.t('referentiels:impression.imprimer'),
    cancelText: i18n.t('referentiels:impression.annuler'),
    onOk: imprimer,
  });
}
